export enum ReviewDataSource {
    KKDAY = 'KKDAY',
    VIATOR = 'VIATOR',
    TRIP_ADVISOR = 'TRIP_ADVISOR',
    UNKNOWN = 'UNKNOWN',
}
